if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia("(min-width: 750px)");
        this.header = document.querySelector(".header-wrapper");
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]'
          ),
          button: this.querySelector("button.localization-form__select"),
          panel: this.querySelector(".disclosure__list-wrapper"),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector(".country-selector__close-button"),
          resetButton: this.querySelector(".country-filter__reset-button"),
          searchIcon: this.querySelector(".country-filter__search-icon"),
          liveRegion: this.querySelector("#sr-country-search-results"),
        };
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
        this.addEventListener("keydown", this.onContainerKeyDown.bind(this));
        this.addEventListener("focusout", this.closeSelector.bind(this));

        if (this.elements.button) {
          this.elements.button.addEventListener(
            "click",
            this.openSelector.bind(this)
          );
        }

        if (this.elements.search) {
          this.elements.search.addEventListener(
            "keyup",
            this.filterCountries.bind(this)
          );
          this.elements.search.addEventListener(
            "focus",
            this.onSearchFocus.bind(this)
          );
          this.elements.search.addEventListener(
            "blur",
            this.onSearchBlur.bind(this)
          );
          this.elements.search.addEventListener(
            "keydown",
            this.onSearchKeyDown.bind(this)
          );
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener(
            "click",
            this.hidePanel.bind(this)
          );
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener(
            "click",
            this.resetFilter.bind(this)
          );
          this.elements.resetButton.addEventListener("mousedown", (event) =>
            event.preventDefault()
          );
        }

        this.querySelectorAll("a").forEach((item) =>
          item.addEventListener("click", this.onItemClick.bind(this))
        );
      }

      hidePanel() {
        if (this.elements.button) {
          this.elements.button.setAttribute("aria-expanded", "false");
        }
        if (this.elements.panel) {
          this.elements.panel.setAttribute("hidden", true);
        }
        if (this.elements.search) {
          this.elements.search.value = "";
          this.filterCountries();
          this.elements.search.setAttribute("aria-activedescendant", "");
        }
        document.body.classList.remove("overflow-hidden-mobile");
        document
          .querySelector(".menu-drawer")
          .classList.remove("country-selector-open");
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll("a")).filter(
          (item) => !item.parentElement.classList.contains("hidden")
        );
        let focusedItemIndex = focusableItems.findIndex(
          (item) => item === document.activeElement
        );
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case "ARROWUP":
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0
                ? focusableItems[focusedItemIndex - 1]
                : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case "ARROWDOWN":
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1
                ? focusableItems[focusedItemIndex + 1]
                : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex(
            (item) => item === document.activeElement
          );
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute(
              "aria-activedescendant",
              focusableItems[focusedItemIndex].id
            );
          } else {
            this.elements.search.setAttribute("aria-activedescendant", "");
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case "ESCAPE":
            if (
              this.elements.button &&
              this.elements.button.getAttribute("aria-expanded") == "false"
            )
              return;
            this.hidePanel();
            event.stopPropagation();
            if (this.elements.button) {
              this.elements.button.focus();
            }
            break;
          case "SPACE":
            if (
              this.elements.button &&
              this.elements.button.getAttribute("aria-expanded") == "true"
            )
              return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;

        // Check if we're in the modal context
        const isModalContext =
          this.closest(".language-modal-container") !== null;

        if (form && !isModalContext) {
          const __isCrossStoreLink = event.currentTarget.classList.contains('cross-store-link');
          console.log('[NILE-DEBUG] localization onItemClick', {
            value: event.currentTarget.dataset.value,
            isCrossStoreLink: __isCrossStoreLink,
            host: window.location.hostname,
            formAction: form.action
          });
          // =====================================================
          // Cross-store links navigate to a DIFFERENT NILE store and are handled
          // entirely by cross-store-country-handler.js (it sets the cookie and
          // redirects). Submitting the localization form here as well posts to
          // this store's /localization endpoint, which 302s back to the current
          // page (return_to) and bounces the user off the target store. So bail
          // out here and let the cross-store handler own the redirect.
          // =====================================================
          if (__isCrossStoreLink) {
            console.log('[NILE-DEBUG] localization onItemClick: cross-store -> early return (NO form.submit)');
            return;
          }

          // =====================================================
          // UPDATE COOKIE before form submit for same-store country changes
          // =====================================================
          const isCountryForm = this.querySelector('input[name="country_code"]') !== null;
          const countryCode = event.currentTarget.dataset.value;

          if (isCountryForm && countryCode && window.NileCountryRedirect) {
            // Check if this is a same-store country (not cross-store redirect)
            const isCrossStoreLink = event.currentTarget.classList.contains('cross-store-link');

            if (!isCrossStoreLink) {
              // Same-store country change - update cookie with current language
              const currentStore = window.NileCountryRedirect.getCurrentStore();
              const currentLanguage = window.NileCountryRedirect.getCurrentLanguageFromUrl();
              
              window.NileCountryRedirect.setNilePrefs({
                country: countryCode,
                language: currentLanguage,
                store: currentStore
              });
            }
          }
          
          // For language changes (not country), also update the cookie
          if (!isCountryForm && window.NileCountryRedirect) {
            const languageCode = event.currentTarget.dataset.value;
            const existingPrefs = window.NileCountryRedirect.getNilePrefs();
            
            if (existingPrefs) {
              window.NileCountryRedirect.setNilePrefs({
                country: existingPrefs.country,
                language: languageCode,
                store: existingPrefs.store
              });
            } else {
              // No existing prefs, create new one with current store
              const currentStore = window.NileCountryRedirect.getCurrentStore();
              window.NileCountryRedirect.setNilePrefs({
                country: window.nileDetectedCountry || 'CH',
                language: languageCode,
                store: currentStore
              });
            }
          }
          
          console.log('[NILE-DEBUG] localization onItemClick -> form.submit()', {
            action: form.action,
            value: this.elements.input.value,
            host: window.location.hostname
          });
          form.submit();
        } else if (isModalContext) {
          // For modal context, just update the selection without submitting
          // Update the button text to show selected value
          const button = this.querySelector(".disclosure__button");
          if (button) {
            const valueSpan = button.querySelector(
              "span:not(.icon-wrap):not(.country-flag)"
            );
            if (valueSpan) {
              const displayName =
                event.currentTarget.dataset.displayName ||
                event.currentTarget.dataset.value;
              valueSpan.textContent = displayName;
            }

            const flagSpan = button.querySelector(".country-flag");
            if (flagSpan) {
              const countryCode = event.currentTarget.dataset.value;

              const currentFlagImg = flagSpan.querySelector("img");
              let baseUrl = "";
              if (currentFlagImg && currentFlagImg.src) {
                const urlParts = currentFlagImg.src.split("/");
                urlParts.pop();
                baseUrl = urlParts.join("/") + "/";
              }

              const flagData = {
                CH: { filename: "flag-ch.svg", alt: "Switzerland" },
                DE: { filename: "flag-de.svg", alt: "Germany" },
                AT: { filename: "flag-at.svg", alt: "Austria" },
                BE: { filename: "flag-be.svg", alt: "Belgium" },
                BG: { filename: "flag-bg.svg", alt: "Bulgaria" },
                HR: { filename: "flag-hr.svg", alt: "Croatia" },
                CZ: { filename: "flag-cz.svg", alt: "Czech Republic" },
                DK: { filename: "flag-dk.svg", alt: "Denmark" },
                EE: { filename: "flag-ee.svg", alt: "Estonia" },
                FI: { filename: "flag-fi.svg", alt: "Finland" },
                FR: { filename: "flag-fr.svg", alt: "France" },
                GR: { filename: "flag-gr.svg", alt: "Greece" },
                HU: { filename: "flag-hu.svg", alt: "Hungary" },
                IE: { filename: "flag-ie.svg", alt: "Ireland" },
                IT: { filename: "flag-it.svg", alt: "Italy" },
                LV: { filename: "flag-lv.svg", alt: "Latvia" },
                LT: { filename: "flag-lt.svg", alt: "Lithuania" },
                LU: { filename: "flag-lu.svg", alt: "Luxembourg" },
                MT: { filename: "flag-mt.svg", alt: "Malta" },
                NL: { filename: "flag-nl.svg", alt: "Netherlands" },
                NO: { filename: "flag-no.svg", alt: "Norway" },
                PL: { filename: "flag-pl.svg", alt: "Poland" },
                PT: { filename: "flag-pt.svg", alt: "Portugal" },
                RO: { filename: "flag-ro.svg", alt: "Romania" },
                SK: { filename: "flag-sk.svg", alt: "Slovakia" },
                SI: { filename: "flag-si.svg", alt: "Slovenia" },
                ES: { filename: "flag-es.svg", alt: "Spain" },
                SE: { filename: "flag-se.svg", alt: "Sweden" },
                LI: { filename: "flag-li.svg", alt: "Liechtenstein" },
                CA: { filename: "flag-ca.svg", alt: "Canada" },
                GB: { filename: "flag-gb.svg", alt: "United Kingdom" },
              };

              const countryData = flagData[countryCode];
              if (countryData) {
                const flagUrl = baseUrl + countryData.filename;
                flagSpan.innerHTML = `<img src="${flagUrl}" alt="${countryData.alt}" width="auto" height="14">`;
              } else {
                // Fallback to globe icon
                flagSpan.innerHTML =
                  '<svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.043 8.65234C14.0977 8.37891 14.125 8.07813 14.125 7.77734C14.125 4.66016 11.7734 2.08984 8.76562 1.70703L8.62891 2.19922C9.03906 2.08984 9.47656 2.25391 9.72266 2.60938C10.0781 3.12891 9.88672 3.83984 9.33984 4.11328L7.72656 4.90625C7.61719 4.96094 7.5625 5.07031 7.5625 5.17969C7.5625 5.42578 7.45312 5.67188 7.28906 5.83594L6.76953 6.35547C6.71484 6.41016 6.6875 6.49219 6.6875 6.57422V6.62891C6.6875 6.79297 6.79687 6.92969 6.96094 6.92969C7.07031 6.92969 7.15234 6.875 7.20703 6.79297L7.50781 6.41016C7.67187 6.19141 7.94531 6.05469 8.21875 6.05469C8.46484 6.05469 8.71094 6.13672 8.875 6.30078L8.95703 6.38281C9.01172 6.46484 9.14844 6.46484 9.20312 6.38281L10.0781 5.50781C10.4336 5.15234 11.0625 5.39844 11.0625 5.91797V6.16406C11.0625 6.32813 11.1992 6.46484 11.3633 6.46484H11.4727C12.1016 6.46484 12.457 7.23047 12.0469 7.72266C11.9648 7.85938 11.9648 8.02344 12.1016 8.13281L12.5391 8.48828C12.6758 8.59766 12.8398 8.65234 13.0039 8.65234H14.043ZM13.8516 9.52734H13.0039C12.6211 9.52734 12.2656 9.41797 11.9648 9.17188L11.5273 8.81641C11.1172 8.43359 11.0078 7.83203 11.2539 7.33984C10.7891 7.3125 10.4062 7.01172 10.2422 6.57422L9.83203 7.01172C9.42187 7.42188 8.73828 7.42188 8.32812 7.01172L8.24609 6.92969C8.24609 6.92969 8.24609 6.90234 8.21875 6.90234L8.19141 6.92969L7.89062 7.3125C7.67187 7.61328 7.34375 7.77734 6.96094 7.77734C6.33203 7.77734 5.8125 7.25781 5.8125 6.62891V6.57422C5.8125 6.24609 5.92187 5.94531 6.16797 5.72656L6.66016 5.20703C6.6875 5.20703 6.6875 5.20703 6.6875 5.17969C6.6875 4.74219 6.93359 4.33203 7.34375 4.14063L8.95703 3.32031C9.03906 3.29297 9.06641 3.18359 9.01172 3.10156C8.95703 3.04688 8.875 3.01953 8.82031 3.04688L8.60156 3.15625C8.10938 3.40234 7.53516 2.96484 7.67188 2.41797L7.86328 1.65234C4.52734 1.73438 1.875 4.44141 1.875 7.77734C1.875 11.1406 4.55469 13.875 7.89062 13.9023C7.75391 13.6563 7.50781 13.4648 7.17969 13.4648C6.74219 13.4648 6.30469 13.3008 6.00391 12.9727L5.56641 12.5352C5.15625 12.125 4.9375 11.5781 4.9375 11.0039V10.9219C4.9375 10.1836 5.29297 9.5 5.89453 9.08984L6.66016 8.59766C7.01562 8.35156 7.42578 8.21484 7.86328 8.21484H8.4375C8.95703 8.21484 9.44922 8.40625 9.85937 8.76172L10.5977 9.36328C10.707 9.47266 10.8711 9.52734 11.0352 9.52734C11.4453 9.52734 11.8281 9.69141 12.1289 9.99219L12.2383 10.1016C12.4297 10.293 12.7031 10.4023 12.9766 10.4023H13.5234C13.6602 10.1289 13.7695 9.82813 13.8516 9.52734ZM13.0039 11.2773V11.3047H12.9766C12.457 11.3047 11.9648 11.0859 11.6094 10.7305L11.5 10.6211C11.3633 10.4844 11.1992 10.4297 11.0352 10.4297C10.6523 10.4297 10.2969 10.293 10.0234 10.0469L9.28516 9.41797C9.03906 9.22656 8.73828 9.08984 8.4375 9.08984H7.86328C7.58984 9.08984 7.34375 9.17188 7.125 9.33594L6.38672 9.82812C6.00391 10.0742 5.78516 10.4844 5.78516 10.9219V11.0039C5.78516 11.3594 5.94922 11.6875 6.19531 11.9336L6.63281 12.3711C6.76953 12.5078 6.96094 12.5898 7.17969 12.5898C7.97266 12.5898 8.62891 13.1367 8.82031 13.8477C10.543 13.6289 12.0469 12.6719 13.0039 11.2773ZM8 14.7773C5.48437 14.7773 3.1875 13.4648 1.92969 11.2773C0.671875 9.11719 0.671875 6.46484 1.92969 4.27734C3.1875 2.11719 5.48438 0.777344 8 0.777344C10.4883 0.777344 12.7852 2.11719 14.043 4.27734C15.3008 6.46484 15.3008 9.11719 14.043 11.2773C12.7852 13.4648 10.4883 14.7773 8 14.7773ZM6.11328 3.53906C6.27734 3.70313 6.27734 4.00391 6.11328 4.16797L5.23828 5.04297C5.07422 5.20703 4.77344 5.20703 4.60938 5.04297C4.44531 4.87891 4.44531 4.57812 4.60938 4.41406L5.48438 3.53906C5.64844 3.375 5.94922 3.375 6.11328 3.53906Z" fill="currentColor"/></svg>';
              }
              flagSpan.setAttribute("data-country-code", countryCode);
            }
          }

          const allLinks = this.querySelectorAll(".disclosure__link");
          allLinks.forEach((link) => {
            link.removeAttribute("aria-current");
            const checkmark = link.querySelector("span:first-child");
            if (checkmark) {
              checkmark.classList.add("visibility-hidden");
            }
          });

          event.currentTarget.setAttribute("aria-current", "true");

          const selectedCheckmark =
            event.currentTarget.querySelector("span:first-child");
          if (selectedCheckmark) {
            selectedCheckmark.classList.remove("visibility-hidden");
          }

          this.hidePanel();

          // Trigger Klaviyo update for country changes
          if (this.querySelector('input[name="country_code"]') !== null) {
            const countryCode = event.currentTarget.dataset.value;

            if (countryCode && window.updateCountryOnly) {
              setTimeout(() => {
                window.updateCountryOnly(countryCode);
              }, 100);
            }
          }

          const currentUrl = new URL(window.location);
          const isCountryForm =
            this.querySelector('input[name="country_code"]') !== null;

          if (isCountryForm) {
            currentUrl.searchParams.set(
              "modal_country",
              event.currentTarget.dataset.value
            );
          } else {
            currentUrl.searchParams.set(
              "modal_language",
              event.currentTarget.dataset.value
            );
          }

          const existingCountry = currentUrl.searchParams.get("modal_country");
          const existingLanguage =
            currentUrl.searchParams.get("modal_language");

          if (isCountryForm && existingLanguage) {
            currentUrl.searchParams.set("modal_language", existingLanguage);
          } else if (!isCountryForm && existingCountry) {
            currentUrl.searchParams.set("modal_country", existingCountry);
          }

          window.history.replaceState({}, "", currentUrl);

          if (typeof updateButtonTexts === "function") {
            const countryInput = document.querySelector(
              '#LanguageModalCountryForm input[name="country_code"]'
            );
            const languageInput = document.querySelector(
              '#LanguageModalLanguageForm input[name="locale_code"]'
            );

            if (countryInput && languageInput) {
              updateButtonTexts(countryInput.value, languageInput.value);
            }
          }
        }
      }

      openSelector() {
        if (this.elements.button) {
          this.elements.button.focus();
          this.elements.button.setAttribute(
            "aria-expanded",
            (
              this.elements.button.getAttribute("aria-expanded") === "false"
            ).toString()
          );
        }
        if (this.elements.panel) {
          this.elements.panel.toggleAttribute("hidden");
        }
        if (!document.body.classList.contains("overflow-hidden-tablet")) {
          document.body.classList.add("overflow-hidden-mobile");
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute("data-prevent-hide")) {
          this.header.preventHide = true;
        }
        document
          .querySelector(".menu-drawer")
          .classList.add("country-selector-open");
      }

      closeSelector(event) {
        if (
          event.target.classList.contains("country-selector__overlay") ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector(".popular-countries");
        const allCountries = this.querySelectorAll("a");
        let visibleCountries = allCountries.length;

        if (this.elements.resetButton) {
          this.elements.resetButton.classList.toggle("hidden", !searchValue);
        }
        if (popularCountries) {
          popularCountries.classList.toggle("hidden", searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(
            item.querySelector(".country").textContent
          );
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove("hidden");
            visibleCountries++;
          } else {
            item.parentElement.classList.add("hidden");
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.countrySelectorSearchCount.replace(
              "[count]",
              visibleCountries
            );
        }

        this.querySelector(".country-selector").scrollTop = 0;
        this.querySelector(".country-selector__list").scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = "";
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        if (this.elements.searchIcon) {
          this.elements.searchIcon.classList.add(
            "country-filter__search-icon--hidden"
          );
        }
      }

      onSearchBlur() {
        if (!this.elements.search.value && this.elements.searchIcon) {
          this.elements.searchIcon.classList.remove(
            "country-filter__search-icon--hidden"
          );
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === "ENTER") {
          event.preventDefault();
        }
      }
    }
  );
}

// $(document).ready(function() {
//   // Cache elements
//   const $searchInput = $('.localization-form .command-input-wrapper .field__input');
//   const $countryList = $('.localization-form .countries');
//   const $countryItems = $('.localization-form .disclosure__item');

//   // Add search functionality
//   $searchInput.on('input', function() {
//     const searchTerm = $(this).val().toLowerCase();
//     let hasMatches = false;

//     // Remove any existing no-results message
//     $countryList.find('.no-results').remove();

//     // Filter countries
//     $countryItems.each(function() {
//       const $item = $(this);
//       const countryName = $item.find('.country').text().toLowerCase();
//       const isMatch = countryName.includes(searchTerm);

//       $item.toggle(isMatch);
//       if (isMatch) hasMatches = true;
//     });

//     // Show no results message if needed
//     if (!hasMatches && searchTerm.length > 0) {
//       $countryList.append(
//         '<li class="disclosure__item no-results">' +
//         '<span class="country">No countries found</span>' +
//         '</li>'
//       );
//     }
//   });

//   // Auto-focus search input when dropdown opens
//   $(document).on('click', '.disclosure__button', function() {
//     setTimeout(function() {
//       $searchInput.trigger('focus');
//     }, 50);
//   });

//   // Clear search when closing
//   $(document).on('click', '.country-selector__close-button', function() {
//     $searchInput.val('').trigger('input');
//   });
// });
